
var React = require("react");
var DataHelper = require("../DataHelper.js");
var application = require("../Application.js");
const CircuitsUtil = require('../util/CircuitsUtil')

var dataTimer = null;

class DataComponent extends React.Component {
    static get dataField() {
        return "data";
    };

    setBundleData(data, url = "") {
        if(!data) return {};
        var data1 = {};
        data1[DataComponent.dataField] = data;
        let isError = data1.data && data1.data.error;

        let propsUrl = `${this.props.dataUrl}`;
        if (CircuitsUtil.isLibraryQueryEndpoint(propsUrl)) propsUrl += `&${CircuitsUtil.getLibraryQueryFields()}`;
        propsUrl += `&start=${this.props.pageIndex * this.props.rows}&rows=${this.props.rows}`;

        // Compare urls to not show old results when taking more time to load than newer ones
        if (!url || (url && url === propsUrl)) {
            if(this.props.onNumber) this.props.onNumber(data.numberOfResults || 0, isError);
            this.setState(data1);
        }

        return data1;
    }

    getDataUrl(props) {
        return props.dataUrl;
    }

    componentDidMount() {
        var url = this.getDataUrl(this.props);
        var data = DataHelper.getStaticContextData(this.props, url);
        if (data) {
            this.setBundleData(data);
        } else if (DataHelper.getDataFromDataContext(url)) {
            data = DataHelper.getDataFromDataContext(url);
            this.setBundleData(data);
        } else {
            if (url) {
                // need to send data to datastore and ask for data
                this.getData(url);
            }
        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        if(this.props.dataUrl !== nextProps.dataUrl ||
                this.props.updateView !== nextProps.updateView ||
                this.getDataUrl(this.props) !== this.getDataUrl(nextProps)){

            clearTimeout(dataTimer);
            dataTimer = setTimeout(()=>{
              this.getData(this.getDataUrl(nextProps), this.props.handleError);
            }, 400);

        }
    }

    getData(url, handleError){
        return application.dataStore.getData(url, handleError)
                .then(data => this.setBundleData(data, url))
                .catch(() => this.setBundleData({error: true}));
    }

}

module.exports = DataComponent;
